<template>
	<CloMapGoogleLoader
		:apiKey="apiKey"
		:googleMapsLibraryUrl="googleMapsLibraryUrl"
		:bounds="bounds"
		v-on:zoom_changed="zoomChanged"
		v-on:dragend="dragEnd"
		:mapTypeId="mapTypeId"
		:markers="markers"
	>
		<template slot-scope="{ google, map }">
			<CloMapGoogleMarker
				v-for="marker in markers"
				:key="marker.id"
				:marker="marker"
				:content="marker.content"
				:google="google"
				:map="map"
				:infoWindowZIndex="infoWindowZIndex"
				v-on:marker-click="markerClick"
			/>
			<CloMapGooglePath v-if="path.length" :path="path" :google="google" :map="map" />
			<CloMapGoogleGeoJson v-if="geoJson.length" :path="geoJson" :google="google" :map="map" />
			<CloMapGoogleObservations
				v-if="observations"
				:gridSmall="gridSmall"
				:gridLarge="gridLarge"
				:gridNegativeSmall="gridNegativeSmall"
				:gridNegativeLarge="gridNegativeLarge"
				:showNegativeGrid="showNegativeGrid"
				:showPoints="showPoints"
				:gridSizeZoomThreshold="gridSizeZoomThreshold"
				:pointsZoomThreshold="pointsZoomThreshold"
				:points="points"
				:dataBounds="dataBounds"
				:geoCacheUrl="geoCacheUrl"
				:infoWindow="infoWindow"
				:google="google"
				:map="map"
				:propChangedIncrement="propChangedIncrement"
				:infoWindowZIndex="infoWindowZIndex"
				v-on:marker-click="markerClick"
			/>
		</template>
	</CloMapGoogleLoader>
</template>
<script>
import CloMapGoogleLoader from '@/maps/CloMapGoogle/CloMapGoogleLoader.vue';
import CloMapGoogleMarker from '@/maps/CloMapGoogle/CloMapGoogleMarker.vue';
import CloMapGooglePath from '@/maps/CloMapGoogle/CloMapGooglePath.vue';
import CloMapGoogleGeoJson from '@/maps/CloMapGoogle/CloMapGoogleGeoJson.vue';
import CloMapGoogleObservations from '@/maps/CloMapGoogle/CloMapGoogleObservations.vue';

export default {
	components: {
		CloMapGoogleLoader,
		CloMapGoogleMarker,
		CloMapGooglePath,
		CloMapGoogleGeoJson,
		CloMapGoogleObservations,
	},
	data() {
		return {
			propChangedIncrement: 0,
			infoWindowZIndex: 1,
		};
	},
	props: {
		apiKey: {
			type: String,
			default: '',
		},
		googleMapsLibraryUrl: {
			type: String,
			default: null,
		},
		markers: {
			type: Array,
			default() {
				return [];
			},
		},
		path: {
			type: Array,
			default() {
				return [];
			},
		},
		geoJson: {
			type: Array,
			default() {
				return [];
			},
		},
		deck: {
			type: Array,
			default() {
				return [];
			},
		},
		observations: {
			type: Boolean,
			default: false,
		},
		gridLarge: {
			type: String,
			default: null,
		},
		gridSmall: {
			type: String,
			default: null,
		},
		gridNegativeLarge: {
			type: String,
			default: null,
		},
		gridNegativeSmall: {
			type: String,
			default: null,
		},
		showNegativeGrid: {
			type: Boolean,
			default: false,
		},
		showPoints: {
			type: Boolean,
			default: false,
		},
		gridSizeZoomThreshold: {
			type: Number,
			default: 6,
		},
		pointsZoomThreshold: {
			type: Number,
			default: 10,
		},
		points: {
			type: Array,
			default: null,
		},
		dataBounds: {
			type: Object,
			default: null,
		},
		bounds: {
			type: Object,
			default: null,
		},
		geoCacheUrl: {
			type: String,
			default: null,
		},
		infoWindow: {
			type: Object,
			default: null,
		},
		mapTypeId: {
			type: String,
			default: 'satellite',
		},
		streetViewControl: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		// when this prop changes, we need to force the child component to realize it changed
		showNegativeGrid() {
			this.propChangedIncrement++;
		},
	},
	// TODO:
	// set zoom and center based on the bounds of the data (either path, geoJson, or markers)
	// not sure if this should be done here, or in the child components
	// bounds = new google.maps.LatLngBounds();
	// loop through data and use bound.extend()
	// map.setCenter(bounds.getCenter());
	// map.fitBounds(bounds);
	mounted() {
		//console.log(this.mapTypeId);
	},
	beforeDestroy() {},
	methods: {
		zoomChanged(info) {
			this.$emit('zoom_changed', info);
		},
		dragEnd(info) {
			this.$emit('dragend', info);
		},
		markerClick(marker) {
			this.infoWindowZIndex++;
			this.$emit('marker-click', marker);
		},
	},
};
</script>
<style></style>
